import React from "react"
import {CmCollectionType, CmTeasableType} from "../../types";
import C014StageTeaser from "../C014StageCarousel/C014StageTeaser";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TeaserCard from "../C020TeaserCarousel/TeaserCard";
import CCOContainer from "../../fundamentals/CCOContainer";
import useWindowSize from "../../../utility/useWindowSize";
import C020TeaserCarousel from "../C020TeaserCarousel/C020TeaserCarousel";


export interface Props {
    cmCollection: CmCollectionType
}

function C075Hero(props: Props) {

    const {lowerThanWindowSmall} = useWindowSize();
    const items = props.cmCollection.items || [];
    const stageItem = items[0] as CmTeasableType;
    const teaserItems = items.slice(1);

    const renderGridTeasers = () => {
        if (items.length === 2) {
            return (
                <Grid
                    size={{sm: 12, md: 12}}
                    sx={{
                        display: "flex",
                        alignItems: "stretch",
                        padding: 3
                    }}>
                    <TeaserCard item={items[1]} horizontal hero showAiGeneratedImageLabel/>
                </Grid>
            );
        }

        const sliceEnd = items.length === 3 ? 3 : 4;
        const columnSize = items.length === 3 ? 6 : 4;

        return (
            <Grid container sx={{
                justifyContent: "center"
            }}>
                {teaserItems.slice(0, sliceEnd - 1).map((item, index) => (
                    <Grid
                        key={index}
                        size={{sm: 12, md: columnSize}}
                        sx={{
                            display: "flex",
                            alignItems: "stretch",
                            padding: 3
                        }}>
                        <TeaserCard teasercardLocation="C075 Stage-Teaser-Hero" item={item} hero
                                    showAiGeneratedImageLabel/>
                    </Grid>
                ))}
            </Grid>
        );
    };


    return (
        <>
            <C014StageTeaser dataCypress="heroStageTeaser" item={stageItem} hero showAiGeneratedImageLabel/>
            <CCOContainer width="full" background={"grey"}>
                <Box
                    sx={{
                        position: 'relative',
                        top: {xl: '-164px', md: '-64px', sm: '0'},
                        mb: {xl: '-150px', md: '-60px', sm: '0'},
                    }}
                >
                    {lowerThanWindowSmall ? (
                        <C020TeaserCarousel
                            cmCollection={{...props.cmCollection, items: teaserItems}}
                            background={"grey"}
                            isHeroCarousel={lowerThanWindowSmall}
                            minHeight="350px"
                        />
                    ) : (
                        renderGridTeasers()
                    )}
                </Box>
            </CCOContainer>
        </>
    );
}

export default C075Hero